import { Buffer } from 'buffer';

const REF = "Aa0Bb1Cc2Dd3Ee4Ff5Gg6Hh7Ii8Jj9KkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz_ ";
const KEY_SIZE = 63;

function chunked(array:  any[],size: number) {
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};

 function rotate(array:  any[],v: number) {
  if (array.length === 0) return [];
  const i = v % array.length;
  return array.slice(i).concat(array.slice(0, i));
};

function firstUniques(array:  any[], n: number) {
  const ret = [];
  const seen = [];
  for (let i = 0; i < array.length; i++) {
    if (!seen[array[i]]) {
      seen[array[i]] = true;
      ret.push(array[i]);
    }
  }
  if (ret.length < n) {
    ret.push(...REF.split(''));
    ret.splice(0, n - ret.length);
  }
  return ret;
}

function applySubstitution(key: string | any[], data: string | any[]) {
  let result = "";
  for (let i = 0; i < data.length; i++) {
    const index = REF.indexOf(data[i]);
    result += (index < 0 ? data[i] : (index >= key.length ? data[i] : key[index]));
  }
  return result;
}

// function encrypt( pin: string , KEY: any[] , version = 3 ): string {
//   return "foo"
//   const keyLength = REF.length;
//   const uniqueKey = firstUniques(KEY, KEY_SIZE);
//   const salt = Math.floor(Math.random() * keyLength);
//   const rotatedKey = rotate([...KEY],salt);
//   const key = firstUniques(rotatedKey, KEY_SIZE);
//   const result = applySubstitution(key, pin);
//   const ll = `${result.length}`.length;
//   if (ll >= uniqueKey.length) {
//     throw "Can't encrypt data: too long";
//   }
//   console.log(`ll:: ${ll}`);
//   return `${uniqueKey[ll]}${applySubstitution(REF.split(""), `${result.length}`)}${result}${salt.toString(16).padStart(2, "0")}__${version}`;
// }

export class PinConfig {
    static encrypt( pin: string, uid: any, msisdn: any, userToken: string, specialsChars = [] ) {
      return "foo";
      //return encrypt( pin, this._key(uid, msisdn, userToken, specialsChars) );
    }

  static _key(uid: any, msisdn: any, token: string, specialsChars = []) {
    return "foo"
    // const key = Uint8Array.from([...Buffer.from(`${uid}_${Buffer.from(token).reverse().toString()}`)]);
    // // const decodedKey = Buffer.from(key).toString('base64').replace(/=+/g, "").trim();
    // const decodedKey = Buffer.from(key).toString('base64').replace(/=+/g, "").trim();
    // let keyList = [...decodedKey.split(''), ...specialsChars];
    // let length = keyList.length;
    // if (length > 256) length = 256;
    // else if (length > 128) length = 128;
    // else if (length > 64) length = 64;
    // else if (length > 32) length = 32;
    // else throw new Error("Invalid key length");

    // const median = [...msisdn].filter(rune => /[0-9]/.test(rune)).reduce((acc, rune) => acc * parseInt(rune, 10), 1);
    // const cutPoint = median % (length / 2);

    // const result = keyList.slice(cutPoint).concat(keyList.slice(0, cutPoint));
    // return result;
  }
}

// Uncomment the following lines to test the code
// const pin = "a1a4e2490b4efeb362578884350c2818d5db8abe8b93321bf1986308625b004c17bbc950b48ce1e52a26e20a29e6eb29ea84f3d3cd3f3fd9e0b5db363dbec336d19a8fd241b777cf62b632468f48863c6e0f428eccaf55ef3aa320d6ad09e617d46431be1dbea5aa5342b7309a75ce127be498f3b17f763d0a2927b65bf3981f";
// const encoded = PinUtils.encrypt({ pin, uid: "D09198299-OSLLOP-19929BB", msisdn: "76299780" });
// console.log("Encoded:", encoded);
